import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, groupBy, map, mergeMap, of, switchMap} from 'rxjs';
import {BelegService} from '../../openapi/fakturierung-openapi';
import {BelegAktualisierungenActions} from '../actions/beleg-aktualisierungen.actions';


/**
 * Laedt ueber den separaten aktualisierungen-Endpoint, welche Datenbereiche eines Belegs
 * gegenueber dem eingefrorenen Stand aktualisiert werden koennen.
 */
@Injectable()
export class BelegAktualisierungenEffects {

  constructor(
    private readonly actions$: Actions,
    private readonly belegService: BelegService,
  ) {
  }

  readonly loadBelegAktualisierungen$ = createEffect(() => this.actions$.pipe(
    ofType(BelegAktualisierungenActions.loadBelegAktualisierungen),
    // INFO: pro Beleg eigener switchMap — ein Beleg-Wechsel darf den Request eines anderen
    //       Belegs nicht wegcanceln, ein erneuter Load desselben Belegs schon.
    groupBy(({belegId}) => belegId),
    mergeMap(perBeleg$ => perBeleg$.pipe(
      switchMap(({betriebId, belegId}) =>
        this.belegService.readBelegAktualisierungen(betriebId, belegId).pipe(
          map(aktualisierungen => BelegAktualisierungenActions.loadBelegAktualisierungenSuccess({
            belegId,
            aktualisierungen,
          })),
          catchError(error => of(BelegAktualisierungenActions.loadBelegAktualisierungenFailure({
            belegId,
            error,
          }))),
        ),
      ),
    )),
  ));
}
